angular.module('manufacturing')
    .controller('ManufacturingOrderHelpController', function ($scope, $rootScope, $uibModalInstance) {
        this.cancel = () => $uibModalInstance.dismiss('cancel')
    })
